module.exports = __webpack_public_path__ + "gl.svg?f74352300b907585a4d81cd0270aaccb";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/gl.svg
// module id = 1259
// module chunks = 27